import * as React from 'react'
import './App.css'
import Footer from './components/Shared/footer/footer.conn'

export class App extends React.Component<any> {
  componentDidMount() {
    this.props.fetchAllContent()
  }
  public render() {
    return (
      <div className="App">
        {this.props.children}
        <Footer />
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.tsx